module.exports = __webpack_public_path__ + "img/tida-color.54febe6c.png";